import React, { useState, useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Toolbar, { modules } from "./Toolbar";

const RichTextEditor = ({ defaultValue, changeHandler, valueResetDependency, disabled, formats1, formats2, colours, link, reset }) => {
  const [input, setInput] = useState("");

  useEffect(() => {
    setInput(defaultValue);
  }, [valueResetDependency]);

  const updateInput = (value) => {
    setInput(value);
    changeHandler(value);
  };
  return (
    <>
      <style>
        {`
          .ql-editor { min-height: 150px !important; }
          .ql-tooltip { position: static !important; }
          .ql-tooltip input[type=text] { width: 350px !important; }
        `}
      </style>
      {disabled && <style>{`.ql-editor { background-color: #f0f0f0 !important }`}</style>}
      <Toolbar formats1={formats1} formats2={formats2} colours={colours} link={link} reset={reset} />
      <ReactQuill modules={modules} value={input} onChange={updateInput} readOnly={disabled} />
    </>
  );
};

export default RichTextEditor;

/**************************************Documentations**************************************/
//react-quill     => https://www.npmjs.com/package/react-quill
//Custom Toolbar  => https://medium.com/@mircea.calugaru/react-quill-editor-with-full-toolbar-options-and-custom-buttons-undo-redo-176d79f8d375
